import React, { useState, useEffect, Fragment } from 'react'
import Layout from '../modules/Layout'
import { useTranslation } from 'react-i18next'
import Image from '../atoms/Image'
import Link from '../atoms/Link'
import Richtext from 'gatsby-theme-kn/src/components/atoms/Richtext'
import OneColWrapper from 'gatsby-theme-kn/src/components/technical/OneColWrapper'
import SEO from '../modules/Seo'
import { Listbox } from '@headlessui/react'

import FadeInBottomEffect from '../effect/FadeInBottomEffect'
import DealerSearchBlock from '../blocks/DealerSearchBlock'

const ProductCategoryPage = ({
  locale,
  content,
  name,
  products,
  alternates,
}) => {
  const { t } = useTranslation()

  const [selectedFilter, setSelectedFilter] = useState('all')
  const [allProducts, setAllProducts] = useState([...products])
  const [searchIn, setSearchIn] = useState('')
  const [searchFor, setSearchFor] = useState('')
  const [selectedCategory, setSelectedCategory] = useState('')

  useEffect(() => {
    setSearchIn(`${t('product_category_page.searching_in')}`)
    setSearchFor(`${t('product_category_page.searching_for')}`)
  }, [locale])

  useEffect(() => {
    content.collection_links.filter((link) => {
      if (link.slug === content.collection_settings.value) {
        setSelectedCategory(link.title)
      }
    })
    return () => {
      setSelectedCategory('')
    }
  }, [])

  let filtersData = []
  let mainCategories = []

  products.forEach((p) => {
    mainCategories.push(p.content.main_category?.title)
    p.content.tag_lists?.forEach((t) => {
      //console.log(p)
      filtersData.push(t)
    })
  })

  const filters = filtersData.reduce((acc, current) => {
    const x = acc.find((item) => item.title === current.title)
    if (!x) {
      return acc.concat([current])
    } else {
      x.tags = x.tags.concat(current.tags)
      return acc
    }
  }, [])

  // remove duplicates from tags based on the title
  filters.forEach((f) => {
    f.tags = f.tags.reduce((acc, current) => {
      const x = acc.find((item) => item.title === current.title)
      if (!x) {
        return acc.concat([current])
      } else {
        return acc
      }
    }, [])
  })

  const filterProducts = (filter) => {
    console.log(filter)
    if (filter === 'all') {
      setAllProducts([...products])
    } else {
      const filteredProducts = products.filter((p) => {
        let found = false
        p.content.tag_lists?.forEach((t) => {
          console.log(t)
          t.tags.forEach((tag) => {
            if (tag.title === filter) {
              found = true
            }
          })
        })
        return found
      })
      setAllProducts([...filteredProducts])
    }
  }

  const handleChange = (e) => {
    console.log(e)
    setSelectedFilter(e)
    filterProducts(e, products)
  }

  useEffect(() => {
    return () => {
      setAllProducts([...products])
    }
  }, [locale])

  return (
    <Layout locale={locale} alternates={alternates}>
      <SEO content={content} name={name} og_locale={locale} />
      <section className="skewed-block skewed-block-on-gray">
        <div className="skewed-block-space"></div>
        <div className="skewed-block-effect"></div>
      </section>

      <section className="item-grid-block category-page">
        <div className="item-grid-block-container">
          <div className="item-grid-block-wrapper">
            <div className="item-grid-block-header">
              <h1>{content.collection_links?.[0].title}</h1>
            </div>
            <div className="item-grid-block-header-filter">
              <span className="d-none d-md-inline-block">{searchIn}</span>
              <div className="dropdown">
                <Listbox>
                  <Listbox.Button className="btn btn-outline-secondary dropdown-toggle">
                    {name !== mainCategories[0]
                      ? selectedCategory
                      : t('product_category_page.all')}
                  </Listbox.Button>
                  <Listbox.Options className="dropdown-menu show">
                    {content.collection_links?.map((item, index) => (
                      <Listbox.Option key={index}>
                        <Link
                          className="dropdown-item"
                          link={`/${item.full_slug}`}
                        >
                          {item.title !== mainCategories[0]
                            ? item.title
                            : t('product_category_page.all')}
                        </Link>
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>
                </Listbox>
              </div>
              <span className="d-none d-md-inline-block">{searchFor}</span>
              <div className="dropdown">
                <Listbox value={selectedFilter} onChange={handleChange}>
                  <Listbox.Button className="btn btn-outline-secondary dropdown-toggle">
                    {selectedFilter === 'all'
                      ? `${t('product_category_page.features')}`
                      : selectedFilter}
                  </Listbox.Button>
                  <Listbox.Options className="dropdown-menu show">
                    <Listbox.Option value={'all'} className="dropdown-item">
                      {t('product_category_page.all')}
                    </Listbox.Option>
                    {filters.map((item, index) => (
                      <Fragment key={index}>
                        <h6 className="dropdown-header text-left">
                          {item.title}
                        </h6>
                        {item.tags.map((tag, index) => (
                          <Listbox.Option
                            value={tag.title}
                            key={index}
                            className="dropdown-item"
                          >
                            {tag.title}
                          </Listbox.Option>
                        ))}
                      </Fragment>
                    ))}
                  </Listbox.Options>
                </Listbox>
              </div>
            </div>
            <div className="item-grid-block-body" id="product-filter-wrapper">
              {allProducts?.length > 0 &&
                allProducts.map((item, index) => (
                  <FadeInBottomEffect
                    key={index}
                    className={`${
                      products.length < 3
                        ? 'item-grid-block-item-primary'
                        : (index + 1) % 6 == 0 || (index + 1) % 6 == 1
                        ? 'item-grid-block-item-primary'
                        : 'item-grid-block-item'
                    }`}
                  >
                    <Link
                      link={`/${item.full_slug}`}
                      className="item-grid-block-item-content"
                    >
                      <div className="item-grid-block-item-image">
                        <Image
                          className="img-fluid item-grid-block-item-image-big"
                          image={item.content.isolated_image}
                          imageWidth="540"
                          imageHeight="324"
                          fillColor="FFFFFF"
                          alt={`${item.name} - ${item.content.headline}`}
                        />
                        <Image
                          className="img-fluid item-grid-block-item-image-small"
                          image={item.content.isolated_image}
                          imageWidth="255"
                          imageHeight="255"
                          fillColor="FFFFFF"
                          alt={`${item.name} - ${item.content.headline}`}
                        />
                      </div>
                      <div className="item-grid-block-item-text">
                        <h4>
                          <span>{item.name}</span>
                        </h4>
                        <p>{item.content.headline}</p>
                      </div>
                      {item.content.uploads?.main_award?.length > 0 && (
                        <div className="item-grid-block-item-eyecatcher">
                          <div
                            className="item-grid-block-item-eyecatcher-content"
                            style={{
                              backgroundImage: `url(${item.content.uploads?.main_award[0].preview_url})`,
                            }}
                          >
                            <span>{item.content.title}</span>
                          </div>
                        </div>
                      )}
                    </Link>
                  </FadeInBottomEffect>
                ))}
            </div>
          </div>
        </div>
      </section>
      <section
        className="product-category-description-block"
        style={{ background: '#f6f6f6' }}
      >
        <OneColWrapper block={{}}>
          <Richtext text={content.product_category_description} />
        </OneColWrapper>
      </section>
      <DealerSearchBlock block={{}} />
    </Layout>
  )
}

export default ProductCategoryPage
